// src/components/AgentCommandCenter/ExpandedConsoleModal.js
import React, { useState } from 'react';
import { assetPath } from 'utils/getBasePath';
import './ExpandedConsoleModal.css';

const ExpandedConsoleModal = ({
    isOpen,
    onClose,
    client,
    onOpenOutcomeModal,
    callStatus,
    onAcceptCall,
    onRejectCall,
    onHangupCall,
    isActive = true,
}) => {
    const [agentNotes, setAgentNotes] = useState('');

    if (!isOpen) return null;

    // Format call duration (for display purposes)
    const formatCallDuration = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    // Get appropriate call status text
    const getCallStatusText = () => {
        switch (callStatus) {
            case 'incoming':
                return 'INCOMING CALL';
            case 'in-progress':
                return 'ACTIVE CALL - ' + formatCallDuration(300); // Example: 5 minutes (300 seconds)
            case 'ready':
                return isActive ? 'READY FOR CALLS' : 'AGENT OFFLINE';
            case 'idle':
                return 'INITIALIZING...';
            case 'error':
                return 'TWILIO ERROR';
            default:
                return 'NOT CONNECTED';
        }
    };

    return (
        <div className='expanded-modal-overlay'>
            <div className='expanded-modal-content'>
                <div className='expanded-modal-header'>
                    <h3>Agent Call Console</h3>
                    <div
                        className={`call-status ${callStatus} ${!isActive && callStatus === 'ready' ? 'offline' : ''}`}
                    >
                        {getCallStatusText()}
                    </div>
                    <button className='modal-close-btn' onClick={onClose}>
                        &times;
                    </button>
                </div>

                <div className='expanded-console-body'>
                    {/* Left half */}
                    <div className='expanded-left'>
                        <div className='client-info-card'>
                            <h4>Client Information</h4>
                            <p>
                                <strong>Name:</strong> {client.name}
                            </p>
                            <p>
                                <strong>Phone Number:</strong> {client.phoneNumber}
                            </p>
                            <p>
                                <strong>Email:</strong> {client.email}
                            </p>
                            <p>
                                <strong>Campaign:</strong> {client.campaign}
                            </p>
                            <p>
                                <strong>Location:</strong> {client.location}
                            </p>
                        </div>

                        {/* Temporarily hidden: Qualifications section */}
                        {/*
                        <div className="qualifications-section">
                            <h4>Qualifications</h4>
                            {qualifications.map((qual, idx) => (
                                <div key={idx} className="qualification-badge">
                                    {qual}
                                </div>
                            ))}
                        </div>
                        */}

                        {/* Temporarily hidden: Call Transcript section */}
                        {/*
                        <div className="transcript-section">
                            <h4>Call Transcript</h4>
                            <div className="transcript-messages expanded">
                                {transcriptMessages.map((msg, i) => (
                                    <div
                                        key={i}
                                        className={`msg-row ${
                                            msg.sender === 'SLAI Agent' ? 'agent' : 'client'
                                        }`}
                                    >
                                        <p className="sender">{msg.sender}</p>
                                        <div className="msg-bubble">{msg.text}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        */}

                        <div className='mic-row' style={{ marginTop: '1rem' }}>
                            <img src={assetPath('/icons/mic.png')} alt='Mic' />
                            <span>Microphone on.</span>
                        </div>
                    </div>

                    {/* Right half: big notes area */}
                    <div className='expanded-right'>
                        <textarea
                            className='notes-textarea'
                            placeholder='Type call notes here...'
                            value={agentNotes}
                            onChange={(e) => setAgentNotes(e.target.value)}
                            style={{ height: '300px' }}
                        ></textarea>

                        {/* Call status and details section */}
                        <div className='call-details-section'>
                            <h4>Call Details</h4>
                            <div className='call-details-grid'>
                                <div className='call-detail-item'>
                                    <span className='detail-label'>Status:</span>
                                    <span
                                        className={`detail-value status-${!isActive && callStatus === 'ready' ? 'offline' : callStatus}`}
                                    >
                                        {callStatus === 'ready' && !isActive ? 'OFFLINE' : callStatus.toUpperCase()}
                                    </span>
                                </div>
                                {callStatus === 'in-progress' && (
                                    <>
                                        <div className='call-detail-item'>
                                            <span className='detail-label'>Duration:</span>
                                            <span className='detail-value'>00:05:00</span>
                                        </div>
                                        <div className='call-detail-item'>
                                            <span className='detail-label'>Quality:</span>
                                            <span className='detail-value'>Good</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom call actions */}
                <div className='expanded-call-actions'>
                    {callStatus === 'incoming' ? (
                        <>
                            <button className='answer-btn' onClick={onAcceptCall}>
                                Answer
                            </button>
                            <button className='decline-btn' onClick={onRejectCall}>
                                Decline
                            </button>
                        </>
                    ) : callStatus === 'in-progress' ? (
                        <>
                            <button className='hold-btn'>Hold</button>
                            <button className='decline-btn' onClick={onHangupCall}>
                                Hang Up
                            </button>
                            <button className='outcome-btn' onClick={onOpenOutcomeModal}>
                                Call Outcome
                            </button>
                        </>
                    ) : (
                        <button className='outcome-btn' onClick={onOpenOutcomeModal}>
                            Call Outcome
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ExpandedConsoleModal;
